import { Box, Button, Container, makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';
import Footer from '../partials/Footer';
import Header from '../partials/Header';
import { useAuth0 } from "@auth0/auth0-react";
import { Link, Route } from 'react-router-dom';
import  { Redirect } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    cont: {
        fontSize : 32,
        fontWeight: 700
    },
    paper: {
        display: 'flex',
        justifyContent: 'center',
        alignContent : 'center',
        alignItems: 'center',
        width : 1000,
        height: 400,
        marginTop: 100,
        flexDirection: 'column'
    },
    box: {
        display: 'flex',
        justifyContent: 'center'

    },
    info: {
        marginTop: 20
    },
    info1: {

    },
    button: {
        marginTop : 20
    }
  }));
const Logged = () => {
    const {isAuthenticated} = useAuth0();
    console.log(isAuthenticated)

    const classes = useStyles();

    // let comp;
    // let loged = (
    //     <div>
    //     <Container className = {classes.cont}>
    //         <Header/>
    //     <Paper>
    //         <Typography>
    //         Thank You For Signing In, Well inform you of the developments to the platform 
    //         </Typography>
    //     </Paper>
    //     <Footer/>
    //     </Container>
    //     </div>
    // )
    // let nolog = (
    //     <Redirect to='/'  />
    // )
    // if(isAuthenticated === true) {
    //     comp = loged
    // }else {
    //     comp = nolog
    // }
    return (
        <div className="flex flex-col min-h-screen overflow-hidden">
                <Header/>
            <main className="flex-grow">
                <Box className = {classes.box}>   
                <Paper className = {classes.paper} elevation={3}>
            <Typography className = {classes.cont}>
            Thank You For Signing In
            </Typography>
            <Typography className = {classes.info}>
                You will be regularly updated with the development of the platform and notified first when the platform is online
            </Typography>
            <Typography className = {classes.info1}>
                Feel free to contact us for more information
            </Typography>
            <Link to = '/contactus' size="medium" variant = 'contained' color = 'default' className = {classes.button}>
                Contact Us
            </Link>
            <Typography className = {classes.info}>
                Visit our website datadefence.org to learn more about data privacy and data security
            </Typography>
            <a href = 'https://datadefence.org' size="medium" variant = 'contained' color = 'default' className = {classes.button}>
                Visit DataDefence.org
            </a>
            </Paper>
            </Box>
                </main>
            
        <Footer/>
            
</div>
        
    );
};

export default Logged;